var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_525)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.735352,
    width: 38.2646,
    height: 31.9995,
    rx: 15.9998,
    fill: "#FF7926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0312 11.6061L13.3212 -5.86377C12.1472 -5.43172 11.0295 -4.89635 9.97754 -4.25767L17.0406 11.5967L17.0312 11.6061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0103 -6.00439L22.2627 11.6064L29.4197 -4.46404C28.349 -5.08394 27.2031 -5.60052 26.0103 -6.00439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5342 11.2213L24.2911 -6.5022C23.0795 -6.79337 21.8209 -6.96243 20.5342 -7V11.2213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7597 -6.98145C17.4729 -6.90631 16.2237 -6.70907 15.0215 -6.38972L18.7597 11.221V-6.98145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7959 14.6776L2.09796 5.04102C1.72226 5.98026 1.42171 6.96646 1.19629 7.97145L12.7959 14.6776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9311 16.2179L0.876238 9.83105C0.791706 10.5731 0.735352 11.3244 0.735352 12.0946V12.5736L11.9311 16.2085V16.2179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66114 0.522949C3.98488 1.40584 3.38377 2.34508 2.86719 3.35006L13.9878 13.3624L4.66114 0.522949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3582 21.4116L0.735352 22.5199V24.8586L11.3582 21.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1515 19.6463L0.735352 18.5474V20.7452L11.1515 19.6463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3582 17.8801L0.735352 14.4331V16.7718L11.3582 17.8801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9355 21.4116L38.9998 24.9995V22.5669L27.9355 21.4116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.499 14.6773L38.4837 7.75508C38.2395 6.72192 37.9296 5.70754 37.5257 4.74951L26.499 14.6867V14.6773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4068 12.3202L8.4846 -3.25244C7.52657 -2.53862 6.64368 -1.74966 5.83594 -0.876161L15.4162 12.3108L15.4068 12.3202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1416 19.6459L38.9992 20.7824V18.5L28.1416 19.6459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8877 12.3202L33.6558 -1.13909C32.8199 -2.01258 31.9088 -2.79215 30.9226 -3.49658L23.8877 12.3202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3057 13.3528L36.7268 3.06807C36.1821 2.06308 35.5528 1.11445 34.8484 0.222168L25.3057 13.3528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9998 14.2925L27.9355 17.8804L38.9998 16.7251V14.2925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9995 12.4327V12.0946C38.9995 11.2493 38.9244 10.4133 38.821 9.59619L27.3623 16.2084L38.9995 12.4233V12.4327Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_525"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.735352,
    width: 38.2646,
    height: 31.9995,
    rx: 15.9998,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.071e3c8c66c8e16ab55653b3f0351c98.svg";
export { ForwardRef as ReactComponent };